<template>
  <div
    class="formPopup formPopup1 legal--1 lp-section width-expand"
    :id="`FormPopup1-${pageUid}`">
    <div
      v-show="windowScrollTop > 80"
      class="trigger animate__fadeIn animate--faster flex-middle flex-center flex-column gap-xs cursor-pointer"
      @click="
        track('formPopup1|trigger|click', { value: triggerText }).then(() => {
          isOpened = true;
        })
      "
      :class="`bg-${triggerBackgroundColor} c-${triggerTextColor}`"
      :style="`border: 4px solid var(--c-${triggerBorderColor});`"
      v-if="isNonEmptyString(triggerText) || isNonEmptyString(triggerIcon)">
      <icon
        v-if="isNonEmptyString(triggerIcon)"
        :size="1.7"
        :icon="triggerIcon"></icon>
      <span v-if="isNonEmptyString(triggerText)">{{ triggerText }}</span>
    </div>
    <modal
      :show="isOpened"
      @modal:closed="isOpened = false"
      :title="isSubmitted ? false : title"
      :show-footer="false">
      <div class="form-wrapper text-center max-width-400 margin-auto-inline">
        <base-form
          method="post"
          action="lead/landing-page/lead"
          class="margin-auto-inline"
          v-show="!isSubmitted"
          @form:submit-success="submitHandler"
          :auto-set-default-values="true"
          v-model="formData"
          :config="finalFormConfig"></base-form>
        <div
          class="thank-you-container margin-auto-inline"
          :class="` c-${thankYouTextColor}`"
          v-show="isSubmitted">
          <h3
            class="thank-you-title margin-remove-bottom margin-l-top bold"
            :class="` c-${thankYouTitleColor}`"
            v-if="isNonEmptyString(thankYouTitle)">
            {{ thankYouTitle }}
          </h3>
          <content-blocks
            :content="thankYouText.blocks"
            v-if="
              thankYouText &&
              thankYouText.blocks &&
              thankYouText.blocks.length > 0
            "
            :class="`c-${thankYouTextColor}`">
          </content-blocks>
        </div>
        <div class="after-content text-l margin-2xl-top">
          <content-blocks
            :content="bottomText.blocks"
            v-if="
              bottomText && bottomText.blocks && bottomText.blocks.length > 0
            ">
          </content-blocks>
          <a
            v-if="isNonEmptyString(phoneNumberDisplay)"
            class="flex gap-s flex-middle flex-center margin-s-top"
            :class="`c-${phoneNumberLinkColor}`"
            :href="`tel:${phoneNumber}`"
            @click="
              track('formPopup1|phoneLink|click', { value: phoneNumberDisplay })
            ">
            <icon
              :size="1.5"
              icon="meitav-contact-form-phone"
              theme="text"></icon>
            <span>{{ phoneNumberDisplay }}</span>
          </a>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import useUiElements from "@/client/extensions/composition/useUiElements";
import lpSectionMixin from "@/client/applications/meitavlp/extensions/mixins/lpSection";
import { inject } from "vue";
import _ from "lodash/object";
import useDom from "@/client/extensions/composition/useDom";

export default {
  mixins: [lpSectionMixin],

  setup(props) {
    let pageUid = inject("pageUid");
    let {windowScrollTop} = useDom();
    let schema = {
      triggerIcon: "",
      triggerIconLegend: "",
      triggerText: "",
      title: "",
      formConfig: {},
      thankYouTitle: "",
      thankYouText: {},
      bottomText: {},
      phoneNumber: "",
      phoneNumberDisplay: "",
      triggerBackgroundColor: "",
      triggerBorderColor: "",
      triggerTextColor: "",
      titleColor: "",
      labelColor: "",
      thankYouTitleColor: "",
      thankYouTextColor: "",
      phoneNumberLinkColor: "",
    };
    let overloadedProps = useUiElements({ input: props.sectionData }).props;
    return {
      ...schema,
      ...overloadedProps,
      allData: overloadedProps,
      pageUid,
      trackEvent: inject("trackEvent"),
      track: inject("track"),
      triggerSectionsEvent: inject("triggerSectionsEvent"),
      windowScrollTop,
    };
  },

  data: function () {
    return {
      isSubmitted: false,
      isOpened: false,
      formData: {
        //  fullName: "אביחי בודק",
        //   email: "propush6@gmail.com",
        //  phoneNumber:"0544894582",
      },
      baseFormConfig: {
        fields: {
          fullName: {
            name: "fullName",
            type: "text",
            label: "lp.sections.embeddedForm1.form.fullName",
            validation: {
              required: {},
              minLength: {
                params: {
                  min: 3,
                },
              },
            },
          },
          phoneNumber: {
            name: "phoneNumber",
            type: "text",
            label: "lp.sections.embeddedForm1.form.phoneNumber",
            validation: {
              required: {},
              cleanIsraelyMobilePhoneNumber: {},
            },
          },
          email: {
            name: "email",
            type: "text",
            label: "lp.sections.embeddedForm1.form.email",
            validation: {
              required: {},
              email: {},
            },
          },
          marketingAgreement: {
            name: "marketingAgreement",
            type: "checkbox",
            label: "lp.sections.embeddedForm1.form.marketingAgreement",
            validation: {
              checkedCheckBox: {},
            },
          },
          campaignName: {
            name: "campaignName",
            type: "hidden",
            disabled: true,
            label: "lp.sections.embeddedForm1.form.campaignName",
          },
          sourceUrl: {
            name: "sourceUrl",
            type: "hidden",
            disabled: true,
            default: "DYNAMIC_currentUrl",
          },
        },
        groups: {},
        //buttons: {},
        formHandling: {
          preflight: [
            {
              type: "overloadUrlTrackingParams",
              options: {},
            },
            {
              type: "validation",
              options: {},
            },
          ],
        },
      },
    };
  },
  computed: {
    finalFormConfig() {
      let result = this.baseFormConfig;
      let override = this.formConfig;
      if (this.isNonEmptyString(this.checkboxLabelTooltipBase)) {
        override.fields.marketingAgreement.autoTranslate = false;
        override.fields.marketingAgreement.tooltip =
          override.fields.marketingAgreement.label;
        override.fields.marketingAgreement.label =
          this.checkboxLabelTooltipBase;
        override.fields.marketingAgreement.tooltipIconTheme =
          this.formButtonColor;
      }

      let finalConfig = _.merge(result, override);

      return finalConfig;
    },
  },
  methods: {
    submitHandler() {
      this.track("formPopup1|form|submitSuccess", {});
      this.isSubmitted = true;
    },
    requestFormPopupOpenHandler(e) {
      this.isOpened = true;
    },
  },
};
</script>

<style scoped lang="scss">
.formPopup1 {
  .trigger {
    position: fixed;
    bottom: 70px;
    border-radius: 50%;
    aspect-ratio: 1/1;
    inset-inline-end: var(--margin-m);
    padding: calc(var(--margin-m) * 1.5);
    z-index: var(--z-top-1);
  }
}

.thank-you-container {
  .thank-you-title {
    font-size: calc(var(--font-2xl) * 1.3);
  }

  .content-blocks :deep(p) {
    font-size: var(--font-xl);
  }
}

.after-content {
  :deep(p, span) {
    font-size: var(--font-l);
  }
}

.form-wrapper {
  :deep(.tooltip) {
    width: 300px;
    @media (max-width: 1024px) {
    }
  }

  :deep(.field__controls-wrapper--checkbox) {
    [role="tooltip-content"] {
      font-size: var(--font-xs) !important;
      line-height: 1;

      @media (max-width: 1024px) {
        overflow-y: scroll;
        max-height: 130px;
      }
    }
  }
}
</style>
